<ul class="hvac-browse-options hvac-browse-subcategories">
    <li class="hvac-browse-category" *ngFor="let category of categories$ | async">
        <hvac-browse-subcategory-tile [category]="category"></hvac-browse-subcategory-tile>
    </li>
</ul>
